// AXIOS SETUP
import axios from "axios"

import { notify } from "@/utils"
import { store } from "@/store-init"

const GeneralVersion = '1.0.1'; // Recuperación de contraseña por e-mail y correo, bug-fix de access-form

let api = 'blackfon-v3', // docker, prod, ngrok
	publicWebURI = '/',
	apiURI,
	apiURIMain;

switch (api) {
	case 'docker': // DEV
		apiURI = 'http://localhost:8001/blackfon-api/';
		break;
	case 'prod':
		apiURI = 'https://blackfon.mx/blackfon-api/';
		break;
	case 'blackfon-v3':
		apiURI = 'https://blackfon-v3.mircloud.us/prod/';
		break;
	case 'ngrok':
		apiURI = 'https://d77b3f9801a0.ngrok.app/blackfon-api/';
		break;

}

apiURIMain = apiURI + '';
// apiURIMain = apiURI +  'index.php?r=';

axios.defaults.baseURL = apiURIMain;
axios.defaults.mediaImageRender = apiURIMain + 'img/render/';
axios.defaults.publicURL = 'http://claveverde.mx/';
axios.defaults.timeout = 30000

axios.interceptors.request.use((config) => {
	// Do something before request is sent
	config.headers['Content-Type'] = 'text/plain';
	if (store.getters.authToken)
		config.headers['auth-token'] = store.getters.authToken;
	return config;
}, (error) => {
	// Do something with request error
	return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use((response) => {

	// Do something with response data
	let processing = response.data;

	if (!!processing.class && processing.class == 'danger')
		processing.class = 'error';

	if (processing.msg) {
		notify( processing.msg, ((processing.class) ? processing.class : 'info'))
	}

	return processing;
}, (error) => {
	notify(error.message, ('error'))
	return Promise.reject(error);
});

export {
	GeneralVersion,
	apiURI,	
	publicWebURI,
	apiURIMain
}